import { AppBlocking } from '@mui/icons-material';
import {
  CompactMerchantType,
  MerchantType,
} from '../../../interfaces/delivery-company/merchants';
import driver from '../../delivery-company-components/driver/driver';
import { IconWithText } from './components';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { Typography } from '@mui/material';

interface MerchantWithIconProps {
  merchant?: MerchantType | CompactMerchantType | null;
  centered?: boolean;
  phone_number?: string;
}
export const MerchantWithIcon = ({
  merchant,
  centered,
  phone_number,
}: MerchantWithIconProps) => {
  if (!merchant) return <></>;
  return (
    <div style={{ width: '100%', marginTop: 0 }}>
     <IconWithText centered={centered}>
        {' '}
        {<StorefrontIcon color="primary" fontSize='small' />}
        <span>{merchant.name}</span>{' '}
        <>{phone_number && <p>{phone_number}</p>}</>
      </IconWithText>
      {
        !merchant.is_active && <IconWithText  centered={centered}><AppBlocking fontSize='small' color={"error"}/> <Typography variant='body2' color='error'>Blocked</Typography></IconWithText>
      }
    </div>
  );
};
